import { ChangeEvent, useEffect, useState } from "react";
import { IEstimation, IRepairationCompleteProps, IRepairationCompleteStates } from "./interfaces";
import { Core } from "../../components/infrastructure/core";
import { enmEntityState } from "../../components/infrastructure/models";
import { Button, Form, Radio, RadioChangeEvent } from "antd";
import { StopOutlined, CheckCircleOutlined } from '@ant-design/icons';
import TextArea from "antd/lib/input/TextArea";
import { PriceInput } from "../../components/priceInput";
import { enmRepairationStatus } from "../../baseInfo/repairCase/interfaces";

type LayoutType = Parameters<typeof Form>[0]['layout'];

export const RepairationComplete = (props: IRepairationCompleteProps) => {

    const [state, setState] = useState<IRepairationCompleteStates>({ loading: false, entity: props.entity ?? { RowGuid: Core.newId(), State: enmEntityState.Added } as any });
    const [form] = Form.useForm();

    const formItemLayout = {
        labelCol: { xxl: 6, xl: 6, lg: 8, md: 8, sm: 10, xs: 24 },
        wrapperCol: { xxl: 12, xl: 12, lg: 16, md: 16, sm: 14, xs: 24 }
    };

    const [formLayout] = useState<LayoutType>('horizontal');

    useEffect(() => {
        //const { requestCheck } = state;
        //if (!requestCheck) {
        //    setState({ requestCheck: { RowGuid: Core.newId(), State: enmEntityState.Added } as any });
        //}
    }, []);

    const submit = async () => {
        const { entity } = state;
        if (!entity)
            return;

        const lastIndex = props.repairCase.RepairCaseCenters.length - 1;
        const repairCaseCenter = props.repairCase.RepairCaseCenters[lastIndex];

        setState({ ...state, loading: true });
        const data = {
            complete: {
                RowGuid: entity.RowGuid,
                RepairCaseCenterId: repairCaseCenter.Id,
                Description: entity.Description,
                PayableAmount: entity.PayableAmount,
                Done: entity.Done,
            }
        };

        if (props.onSubmit)
            await props.onSubmit({
                data,
                url: "repaircasecenter/repairationcomplete",
                completeCallback: result => {
                    setState({ ...state, loading: false });
                    if (result.ValidationState.Successful) {
                        Core.successNotification('ثبت نتیجه تعمیرات انجام شد');
                        props.onClose && props.onClose({});
                    }
                }
            });
    };

    const onChangeConfirm = (e: RadioChangeEvent) => {
        const { entity } = state;
        entity.Done = e.target.value;
        if (entity.Done === false)
            entity.PayableAmount = undefined;
        setState({ ...state, entity });
    };

    const onChangeDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const { entity } = state;
        entity.Description = e.target.value;
        setState({ ...state, entity });
    };

    const onChangePayableAmount = (value: any) => {
        const { entity } = state;
        entity.PayableAmount = value;
        setState({ ...state, entity });
    };

    const { steps } = props;
    const estimations = steps.filter(s => s.Substatus === enmRepairationStatus.Estimation);
    const lastEstimation = estimations[estimations.length - 1] as IEstimation;

    return (
        <Form
            form={form}
            scrollToFirstError
            {...formItemLayout}
            layout={formLayout}
            onFinish={submit}
            onReset={() => {
                props.onClose && props.onClose(this);
            }}
            style={{ padding: 0 }}
        >
            <Form.Item
                label={'مشکل دستگاه رفع شده است؟'}
                name={'Done'}
                key={'Done'}
                rules={[{ required: true, message: 'پاسخ اجباری است' }]}
                initialValue={state.entity.Done}
                labelCol={{ style: { lineHeight: 'normal'} }}
            >
                <Radio.Group key={'Done'}
                    onChange={onChangeConfirm}
                    buttonStyle={"solid"}
                    disabled={props.disabled}
                >
                    <Radio value={true}>مشکل رفع شد</Radio>
                    <Radio value={false}>غیرقابل تعمیر است</Radio>
                </Radio.Group>
            </Form.Item>

            <Form.Item
                label={'توضیحات'}
                name={'Description'}
                key={'Description'}
                rules={[{ required: true, message: 'توضیحات اجباری است' }]}
                initialValue={state.entity.Description}
            >
                <TextArea
                    onChange={onChangeDescription}
                    disabled={props.disabled}
                    rows={6}
                />
            </Form.Item>

            <Form.Item
                label={'مبلغ برآورد شده'}
                name={'EstimatedAmount'}
                key={'EstimatedAmount'}
                initialValue={lastEstimation.EstimatedAmount}
            >
                <PriceInput
                    disabled
                    style={{ width: "100%" }}
                />
            </Form.Item>


            <Form.Item
                label={'مبلغ قابل پرداخت'}
                name={'PayableAmount'}
                key={'PayableAmount'}
                rules={[{ required: state.entity.Done, message: 'مبلغ اجباری است' }]}
                initialValue={state.entity.PayableAmount}
            >
                <PriceInput
                    disabled={props.disabled || !state.entity.Done}
                    onChange={onChangePayableAmount}
                    style={{ width: "100%" }}
                />
            </Form.Item>

            {props.disabled === true ? <></> :
                <Form.Item wrapperCol={{ dir: 'ltr' }} style={{ zIndex: 1000, borderTop: '1px solid', borderColor: '#e5e5e5', marginTop: 10 }}>
                    <Button type="primary" htmlType="submit" icon={<CheckCircleOutlined />} loading={state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10 }}>
                        ثبت
                    </Button>

                    <Button type="ghost" htmlType="reset" icon={<StopOutlined />} loading={state.loading} style={{ width: "100px", marginTop: 10, marginBottom: 10, marginLeft: 10, background: '#fff' }}>
                        لغو
                    </Button>
                </Form.Item>
            }
        </Form>
    );
}